<div class="app-content content bg-blue1">
  <div class="content-wrapper">
    <div class="content-header row">
    </div>
    <div class="content-body">
      <section id="portal-egresado">
        <div class="row">
          <div class="col-lg-8">
            <div class="card">
              <div class="card-header">
                <h1 class="font-large-2 text-bold-500">{{ 'TXT_TITLE' | translate }}</h1>
              </div>
              <div class="card-content">
                <div class="card-body">
                  <h2 class="card-title subtitle font-large-1">{{ 'TXT_OBJECTIVE' | translate }}</h2>
                  <hr>
                  <h3 class="card-title font-medium-5">{{ 'TXT_OB1' | translate}}
                    <br><br>{{ 'TXT_OB2' | translate}}</h3>
                </div>
                <img class="img-fluid" src="https://res.cloudinary.com/drtcnv1st/image/upload/v1678297500/Extra/egresado-portal_aq2az7.png">
              </div>
            </div>
          </div>

          <div class="col-lg-4">
            <div class="card bg-gradient-x-info pull-up">
              <div class="card-header">
                <a [routerLink]="">
                  <h2 class="text-center text-bold subtitle text-white font-large-1">{{ 'TXT_GRADUATEDPORTAL' | translate}} </h2>
                </a>
              </div>
              <div class="card-body text-center">
                <div class="col-md-auto">
                  <a class="btn btn-link" [routerLink]="['login']">
                    <h2 class="font-large-1 white">{{ 'TXT_BTNPortal' | translate }}</h2>
                  </a>
                </div>
                <br>
                <div class="row text-center">
                  <h3 class="card-title text-white font-medium-5">{{ 'TXT_GRADUATEDPORTAL1' | translate }}</h3>
                </div>
              </div>
            </div>

            <div class="card">
              <div class="card-body">
                <h2 class="card-title subtitle font-large-1">{{ 'TXT_HOW' | translate }}</h2>
                <hr>
                <div class="col-lg-12">                 
                  <div class="embed-responsive embed-responsive-16by9">
                    <iframe src="https://www.youtube-nocookie.com/embed/6urzEefRT6w" SameSite="Secure"
                    allow="autoplay; encrypted-media" allowfullscreen></iframe>
                  </div>
                </div>
                <div class="col">
                  <br>
                  <h3 class="card-title mb-1 font-medium-5">{{ 'TXT_HOW1' | translate }}</h3>
                </div>
              </div>
            </div>

            
          </div>
        </div>

        <div class="row"><br><br><br></div>
      </section>

    </div>
  </div>
</div>